import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { ToastService } from '../../services/toast.service';
import { AppConstants } from '../../utilities/constant';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-add-custom-sections',
  templateUrl: './add-custom-sections.component.html',
  styleUrls: ['./add-custom-sections.component.scss'],
})
export class AddCustomSectionsComponent implements OnInit {
  newSectionList: any[] = [{}];
  @Input() type: string;
  @Input() roadmapId: string;
  @Input() roadMapSectionId: string;
  @Input() isExtended: boolean;
  @Input() sections: [] = [];
  @Input() roadmapData: [] = [];
  @Input() page: string;
  @Input() sectionName: string;
  queryParams: any={};
  constructor(private route: ActivatedRoute,public modalController: ModalController, public backendService: BackendCallService, public sharedValue: ShareValuesService,
    private toastService: ToastService,private translate: TranslateService
  ) {
    this.route.queryParams.subscribe(async (params) => {
      this.queryParams=params;
    });
  }

  ngOnInit() {

  }

  ionViewWillEnter() {
    if (this.sections.length !== 0) {
      if (this.type =='Section') {
        this.newSectionList = [];
        if(this.page=='libraryPage'){
         if(this.sections.length){
          this.sections.forEach((each: any) => {
            const section = {section: each.sectionName,uiIsEdit:false, isEdit:each.hasOwnProperty('roadMapSectionId') &&each.roadMapSectionId?true:false,isDelete:false,id:each.roadMapSectionId};
            this.newSectionList.push(section);
          });
         }
          else{
            const section = { section: '',uiIsEdit:false,isEdit:false,isDelete:false,id:''};
            this.newSectionList.push(section);
          }
        }else{
          this.sections.forEach((each: any) => {
            const section = {section: each.sectionName, isEdited: false,isDelete:false,id:each.sectionId };
            this.newSectionList.push(section);
          });
        }

      }else if(this.type =='Sub Section'){
        this.newSectionList = [];
        if(this.page=='libraryPage'){
          if(this.sections.length){
            this.sections.forEach((each: any) => {
              const section = { section: each.subSectionName,uiIsEdit:false,isEdit: each.hasOwnProperty('roadMapSubSectionId') && each.roadMapSubSectionId?true:false,isDelete:false,id:each.roadMapSubSectionId};
              this.newSectionList.push(section);
            });
          }else{
            const section = { section: '',uiIsEdit:false,isEdit:false,isDelete:false,id:''};
            this.newSectionList.push(section);
          }
        }else{
          this.sections.forEach((each: any) => {
            const section = { section: each.subSectionName, isEdited: false ,isDelete:false,id:each.subSection_Id};
            this.newSectionList.push(section);
          });
        }

      }
    }
  }

  deleteSections(section,i){
    // this.newSectionList.splice(i,1);
    this.newSectionList.forEach(ele=>{
      if(ele.section===section.section){
        ele.isDelete=true;
      }
    });
      if (this.sections.length !== 0) {
        if (this.type =='Section') {
          if(this.page!='libraryPage'){
            this.roadmapData.forEach((each: any) => {
              if(each.sectionId==section.id){
                const payload={
                  id: this.roadmapId,
                  serviceMachineId: this.queryParams.serviceMachineId,
                  projectId: this.queryParams.project_id,
                  section: [
                    {
                      sectionId: section.id,
                      isDelete: section.isDelete,
                      subSection: [
                        {
                          subSection_Id: '',
                          isDelete: false,
                          steps: [
                            {
                              id: '',
                              isDelete: false
                            }
                          ]
                        }
                      ]
                    }
                  ]
                };
                this.backendService.deleteRoadmapSectionsData(payload).subscribe(
                  (data: any) => {
                    this.toastService.presentToast(data, 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
                  },err=>{
                    this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                  }
                );
              }
            });
          }else{
            const payload={
              type:'section',
              id:section.id
            };
           if(section.id){
            this.backendService.deleteTemplateRoadmapSectionsData(payload).subscribe(
              (data: any) => {
                this.toastService.presentToast(data.value, 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
              },err=>{
                this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
              }
            );
           }
          }
        }else if(this.type =='Sub Section'){
          if(this.page!='libraryPage'){
            this.roadmapData.forEach((eachSection: any) => {
              const subSections=eachSection.subSections;
              subSections.forEach((eachSubSection: any) => {
                if(eachSubSection.subSection_Id==section.id){
                  const payload={
                    id: this.roadmapId,
                    serviceMachineId: this.queryParams.serviceMachineId,
                    projectId: this.queryParams.project_id,
                    section: [
                      {
                        sectionId: eachSection.sectionId,
                        isDelete: false,
                        subSection: [
                          {
                            subSection_Id: section.id,
                            isDelete: section.isDelete,
                            steps: [
                              {
                                id: '',
                                isDelete: true
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  };
                  this.backendService.deleteRoadmapSectionsData(payload).subscribe(
                    (data: any) => {
                      this.toastService.presentToast(data, 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
                    },err=>{
                      this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                    }
                  );
                }
              });
            });
          }else{
            const payload={
              type:'subsection',
              id:section.id
            };
            if(section.id){
              this.backendService.deleteTemplateRoadmapSectionsData(payload).subscribe(
                (data: any) => {
                  this.toastService.presentToast(data.value, 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
                },err=>{
                  this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                }
              );
            }
          }

        }
      }

  }

  close() {
    this.modalController.dismiss();
  }
  submit(form: NgForm) {
    // const sectionsList=[];
    if (form.valid) {
      // const sections=[]
      // sections.push(...Object.values(form.value));
      if (this.type == 'Section') {
        const sectionsList = Object.values(form.value).map((each: any) => ({
            roadMapMasterId: this.roadmapId,
            sectionName: each.section,
            isEdited: each.isEdited,
            isEdit: each.isEdit,
            uiIsEdit:each.uiIsEdit,
            isDelete:each.isDelete,
            title: each.section,
            key: '',
            component: '',
            isActive: true
          }));
        this.modalController.dismiss(sectionsList);
      } else if (this.type == 'Sub Section') {
        const sectionsList = Object.values(form.value).map((each: any) => ({
            roadMapSectionId: this.roadmapId,
            subSectionName: each.section,
            isEdited: each.isEdited,
            isEdit: each.isEdit,
            uiIsEdit:each.uiIsEdit,
            isDelete:each.isDelete,
            selectedSectionName:this.sectionName
          }));
        this.modalController.dismiss(sectionsList);
      } else if (this.type == 'Change Roadmap Name') {

        const data = { type: 'Change Roadmap Name', name: form.value };
        this.modalController.dismiss(data);
      }

    } else {
      form.form.markAllAsTouched();
    }

  }

  addNew(roadMapInp: HTMLElement) {
    // this.scrollSection(ionBtn)
    this.newSectionList.push({ section: '', isEdited: true ,isEdit:false,uiIsEdit:true,isDelete:false});
    console.log(' this.newSectionList', this.newSectionList);
    setTimeout(() => {
      // objDiv.scrollIntoView({behavior:'smooth'});
      roadMapInp.scrollTop = roadMapInp.scrollHeight;
    }, 100);
  }
  scrollSection(ionBtn) {
    setTimeout(() => {
      (ionBtn.el as HTMLElement).scrollIntoView({ behavior: 'smooth' });
    }, 100);

  }

}
